export enum ESubscriptionTier {
	BASIC = 'basic',
	PRO = 'pro',
}

export enum ESubscriptionStatus {
	ACTIVE = 'active',
	CANCELLED = 'canceled',
}
